import React from 'react';
import StyleSheet from './StyleSheet';
import {
  MdDownload,
  MdCalculate,
  MdExpandMore,
  MdChevronRight,
  MdClose,
  MdSchedule,
  MdArrowDropUp,
  MdArrowDropDown,
  MdArrowDownward,
  MdShowChart,
  MdSync,
  MdCheckCircle,
  MdRefresh,
  MdAutorenew
} from 'react-icons/md';

export const Icon = ({ name, size = 24, color = '#000', type = 'Entypo', style, onPress, ...props }) => {
  const flatStyle = StyleSheet.flatten ? StyleSheet.flatten(style) : style;
  
  // Map icon names to react-icons components
  const iconMap = {
    'download': MdDownload,
    'calculator': MdCalculate,
    'chevron-down': MdExpandMore,
    'chevron-right': MdChevronRight,
    'close': MdClose,
    'schedule': MdSchedule,
    // These names used to fall through to the first-letter fallback below
    'arrow-drop-up': MdArrowDropUp,
    'arrow-drop-down': MdArrowDropDown,
    '↓': MdArrowDownward,
    'chart-line': MdShowChart,
    'sync-alt': MdSync,
    'check-circle': MdCheckCircle,
    'refresh': MdRefresh,
    'spinner': MdAutorenew,
  };
  
  const IconComponent = iconMap[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found, displaying first letter`);
    const iconLetter = name ? name.charAt(0).toUpperCase() : '?';
    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size,
          fontSize: size * 0.7,
          color,
          cursor: onPress ? 'pointer' : 'default',
          fontWeight: 'bold',
          userSelect: 'none',
          ...flatStyle
        }}
        onClick={onPress}
        {...props}
      >
        {iconLetter}
      </span>
    );
  }
  
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onPress ? 'pointer' : 'default',
        userSelect: 'none',
        ...flatStyle
      }}
      onClick={onPress}
      {...props}
    >
      <IconComponent size={size} color={color} />
    </span>
  );
};

export default Icon;
